import { Filter, GpuProgram, GlProgram } from 'pixi.js';
import vertex from '../defaults/default2.mjs';
import wgslVertex from '../defaults/default.mjs';
import fragment from './extract-brightness.mjs';
import source from './extract-brightness2.mjs';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const _ExtractBrightnessFilter = class _ExtractBrightnessFilter extends Filter {
  constructor(options) {
    options = { ..._ExtractBrightnessFilter.DEFAULT_OPTIONS, ...options };
    const gpuProgram = GpuProgram.from({
      vertex: {
        source: wgslVertex,
        entryPoint: "mainVertex"
      },
      fragment: {
        source,
        entryPoint: "mainFragment"
      }
    });
    const glProgram = GlProgram.from({
      vertex,
      fragment,
      name: "extract-brightness-filter"
    });
    super({
      gpuProgram,
      glProgram,
      resources: {
        extractBrightnessUniforms: {
          uThreshold: { value: options.threshold, type: "f32" }
        }
      }
    });
    __publicField(this, "uniforms");
    this.uniforms = this.resources.extractBrightnessUniforms.uniforms;
  }
  /**
   * Defines how bright a color needs to be extracted.
   * @default 0.5
   */
  get threshold() {
    return this.uniforms.uThreshold;
  }
  set threshold(value) {
    this.uniforms.uThreshold = value;
  }
};
/** Default values for options. */
__publicField(_ExtractBrightnessFilter, "DEFAULT_OPTIONS", {
  threshold: 0.5
});
let ExtractBrightnessFilter = _ExtractBrightnessFilter;

export { ExtractBrightnessFilter };
//# sourceMappingURL=ExtractBrightnessFilter.mjs.map
